import styled from 'styled-components';

const Content = styled.div`
  min-width: 1px;
`;

export default Content;
